// 获取最后一个继承
export default function getProtoList(Func) {
    let prev = null;
    let lastProto = null;
    let current = Func;

    while(current) {
        let __proto = Object.getPrototypeOf(current);

        if (__proto) {
            lastProto = prev;
            prev = current;
            current = __proto
        } else {
            current = null;
        }
    }

    return lastProto;
}